// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3JZCZ","label":"Radio_label__3Y22h","checkMark":"Radio_checkMark__1wI-f","disabled":"Radio_disabled__8Rtqd"};